module.exports = __webpack_public_path__ + "static/media/ws.3ea6d44f.svg";